import { TASK_CONST } from '@/constant';
import type { Task, WorkProgress } from '@/type';

export const mapTaskStateToWorkProgress = (task?: Task): WorkProgress => {
  if (!task) return 'Not started';

  if (
    task.state === TASK_CONST.TASK_WORKSTATE.NONE ||
    task.state === TASK_CONST.TASK_WORKSTATE.PENDING ||
    task.state === TASK_CONST.TASK_WORKSTATE.READY
  ) {
    return 'Not started';
  }

  if (task.state === TASK_CONST.TASK_WORKSTATE.PROGRESS) {
    return 'In progress';
  }
  if (task.state === TASK_CONST.TASK_WORKSTATE.COMPLETED) {
    return 'Completed';
  }
  if (task.state === TASK_CONST.TASK_WORKSTATE.FAIL) {
    return 'Failed';
  }

  return 'Not started';
};

export const getUnassignedFrameRangeList = ({
  frameRangeByUser,
  task,
}: {
  frameRangeByUser: { [id: string]: [number, number] };
  task: { startFrameSeq: number; endFrameSeq: number; workFrameCount: number };
}) => {
  const { startFrameSeq, endFrameSeq, workFrameCount } = task;
  const checkedBuffer = new Uint8Array(workFrameCount);

  for (const userID in frameRangeByUser) {
    const [start, end] = frameRangeByUser[userID];

    const fillStart = Math.max(start, startFrameSeq) - startFrameSeq;
    const fillEnd = Math.min(end, endFrameSeq) - startFrameSeq;

    if (fillStart <= fillEnd) {
      checkedBuffer.fill(1, fillStart, fillEnd + 1);
    }
  }

  const emptyFrameRangeList: [number, number][] = [];
  let gapStart: number | null = null;

  for (let i = 0; i < workFrameCount; i++) {
    const isChecked = checkedBuffer[i] === 1;

    if (!isChecked && gapStart === null) {
      gapStart = i + startFrameSeq;
    } else if (isChecked && gapStart !== null) {
      emptyFrameRangeList.push([gapStart, i + startFrameSeq - 1]);
      gapStart = null;
    }
  }

  if (gapStart !== null) {
    emptyFrameRangeList.push([gapStart, endFrameSeq]);
  }

  return emptyFrameRangeList;
};
